var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "price" }, [
    _vm.prices && _vm.price
      ? _c("span", [
          _c("span", { staticClass: "price__value" }, [
            _vm._v(_vm._s(_vm.priceFormatted)),
          ]),
        ])
      : _c("span", { staticClass: "price__placeholder" }, [
          _vm._v(_vm._s(_vm.placeholder)),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }